  <template>
    <div id="app">
    
       <Menu v-if="this.$route.path !== '/'"></Menu> 
      <router-view />
    </div>
  </template>

<script>
import Menu from './components/menu.vue';
import {provide} from 'vue';
import store from '@/store'

export default {
setup() {
provide('store' ,store)
},
  components: {
    Menu
  }
}
</script>
<style >
  @import './assets/nprogresscustom.css';
.logout {
    float: right;
    transition: width .35s;
    -webkit-transition: width .35s;
    overflow: hidden;
    border-radius: 10px;
    
}
</style>